import { GateTypes, RequirementMap } from '@/types/registration.types';
import handleAccessTypeRequirementsChange from './handle-access-type-requirements-change';

const buildWorkingRequirementsMap = ({
  sourceMap,
  access,
  allowDomains,
  sharedPasscode,
}: {
  sourceMap: RequirementMap;
  access: GateTypes | null;
  allowDomains: string[];
  sharedPasscode: string;
}): RequirementMap => {
  const baseMap = handleAccessTypeRequirementsChange({
    requirementsMap: sourceMap,
    projectGateType: access,
  });

  if (access === GateTypes.domain_email) {
    const existing = baseMap[GateTypes.domain_email];
    if (existing) {
      return {
        ...baseMap,
        [GateTypes.domain_email]: { ...existing, allowedDomains: allowDomains },
      };
    }
  }

  if (access === GateTypes.shared_passcode) {
    const existing = baseMap[GateTypes.shared_passcode];
    if (existing) {
      return {
        ...baseMap,
        [GateTypes.shared_passcode]: { ...existing, sharedPasscode },
      };
    }
  }

  return baseMap;
};

export default buildWorkingRequirementsMap;
